module.exports = __webpack_public_path__ + "static/media/gloobinho.7247b633.png";